<template>
  <div
    ref="jGrid"
    class="j-grid"
    :style="style"
    v-on:resize="debounceOnResize"
  >
    <slot>
    </slot>
  </div>
</template>

<script>
import debounce from '@/helpers/debounce'

export default {
  props: {
    aspectRatio: {
      type: Number,
      default: 1,
    },
    gap: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Number,
      default: 12,
    },
  },
  data() {
    return {
      gridItemWidth: 1,
    }
  },
  computed: {
    // gridWidth() {
    //   return 400 // this.$refs.jGrid.clientWidth
    // },
    style() {
      return {
        'grid-template-columns': `repeat(${this.columns}, 1fr)`,
        'grid-auto-rows': `${this.gridItemHeight}px`,
        'grid-gap': this.gap + 'px',
      }
    },
    gridItemHeight() {
      return this.gridItemWidth * this.aspectRatio / this.columns
    },
  },
  mounted() {
    this.updateGridItemWidth()
  },
  methods: {
    updateGridItemWidth() {
      console.log('updateGridItemWidth', this.$refs, this.$refs.jGrid, this.$refs.jGrid.clientWidth)
      this.gridItemWidth = this.$refs.jGrid.clientWidth
    },
    debounceOnResize: debounce(function () {
      console.log('debounceOnResize')
      this.updateGridItemWidth()
      // this.gridItemWidth = this.$refs.jGrid.clientWidth
      // this.$refs.jGrid.clientWidth * this.aspectRatio / 12
      // this.chart.resize(this.$refs.jGrid.clientWidth, this.$refs.jGrid.clientWidth * this.aspectRatio)
    }, 300),
  },
}
</script>

<style lang="scss">
.j-grid {
  display: grid;
  // --noOfColumns: 12;
  // --rowHeight: calc((var(--wrapperWidth) - (var(--noOfGutters) * var(--gutter))) / var(--noOfColumns));

  // .j-grid-item {
  //   border: 1px orange solid;

  //   &::before {
  //     content: "";
  //     padding-bottom: 100%;
  //     display: inline-block;
  //     vertical-align: top;
  //   }
  // }
}
</style>